import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsMessage from "graphql/fields/FieldsMessage";

const fields = {
	'is_read': 'String',
	'active': 'String',
};

export default gql(`
	mutation messages( ${ HelperGraphql.createFields( fields ) } ) {
	    messages( ${ HelperGraphql.createVariables( fields ) } ) {
	        ${FieldsMessage}
	        
	        attachment {
	            name
	            guid
	        }
	    }
	}
`);

